import { styled } from '../Theme';

export const NAVBAR_HEIGHT = '55px';

export const NavbarStyle = styled.nav`
  min-height: ${NAVBAR_HEIGHT};
  max-height: ${NAVBAR_HEIGHT};
  z-index: 200;
  background: #e0e1e2;
  padding: 0 16px 0 0;
  display: flex;

  position: fixed;
  top: 0;
  left: 0;
  right: 0;

  .title {
    display: flex;
    flex: 1 1 auto;
    min-height: 100%;
  }

  .title > * {
    padding: 2px;
  }

  img.logo {
    height: 100%;
    width: auto;
    max-width: 100%;
    padding: 10px;
  }

  .navbar > .title > .navbar-logo:hover {
    cursor: pointer;
  }

  .navbar-nav {
    display: flex;
    margin: 0px;
    flex-direction: row;
  }

  .navbar-nav > li {
    display: flex;
    flex-direction: column;
    justify-content: center;
    text-align: center;
    margin-left: 1em;
  }

  .menu.transition {
    min-width: 200px;
  }
`;
